import type { ProxyIpRangeConfig } from '@/lib/models/connector/proxy-connector.model';
import type { ListItem } from '../list-editor';

export const toListItems = (configs: ProxyIpRangeConfig[] | undefined): ListItem[] => {
  if (!configs?.length) {
    return [];
  }
  return configs.map(({ cidr, status }) => ({
    label: cidr,
    value: cidr,
    meta: { status },
  }));
};

export const fromListItem = (item: ListItem): ProxyIpRangeConfig => ({
  cidr: String(item.value ?? ''),
  status: ((item.meta?.status as ProxyIpRangeConfig['status']) ?? 'pending'),
});
